import {ID_MAP_EXTRA_FIELDS,COUPON_TYPE_OPTIONS_VALUE,COLUMN_NAME_MAP_DB_COLUMN_NAME, DB_COLUMN_NAME_MAP_COLUMN_NAME,removeEntites} from "./utils"
import {CouponEditType, CouponTimingSlab, Recurrence, manageCouponInitialStateType,sectionEnabledType,usabilityLimitsType} from "../types"
import { getOutletTabsList,getMarketTabsList } from "../components/DefineCoupon/MarketDetails/service";
import { createOptionsWithLabel, generateRandomId, getAllProducts } from "../services/services";
import { getHeadersList } from "../components/DefineCoupon/productSelection/service";
import store from "../../../stateManagement/store";
import dayjs from "dayjs";
import { any } from "underscore";
import { applyLocationFilter } from "../components/DefineCoupon/MarketDetails/configData";
import { convertTimeStringToCouponTiming } from "../components/DefineCoupon/recurrence/RecurrenceService";
import { deepClone } from "@mui/x-data-grid/utils/utils";

export default async function transformData(schemeData: Record<string, any>, editType: CouponEditType): Promise<manageCouponInitialStateType> {
    await getAllProducts();

    const finalObject: manageCouponInitialStateType = {
        configData: {
            currentTab: editType === "edit" ? "2" : "0",
            entities: await getProductEntities(schemeData),
            marketLevelTabsList: applyLocationFilter() ? await getMarketTabsList() : null,
            outletLevelTabsList: await getOutletTabsList(),
        },
        data: {
            isSchemePlayground: false,
            couponId: schemeData["schemeId"],
            couponEditType: editType,
            deleteParent: false,
            couponTitle: schemeData["schemeName"],
            couponTypeOption: getCouponTypeOption(schemeData),
            schemeType: getSchemeType(schemeData),
            skipMarketSelection: getSkipMarketSelection(schemeData),
            isOverAndAbove: checkIfOverAndAbove(schemeData),
            schemeProductBifurcationsList: fillAttributes("schemeProductDetails", schemeData),
            mustBuy: {
                active: getIfMustBuy(schemeData),
                quantityUnit: getQuantityUnit(schemeData),
                data: fillMustBuyData(schemeData),
            },
            slabInfo: {
                slabUnit: getSlabUnit(schemeData),
                quantityUnit: getSlabQuantityUnit(schemeData),
                data: getSlab(schemeData)
            },
            schemeLocationBifurcationsList: fillAttributes("schemeLocationDetails", schemeData),
            schemeOutletBifurcationsList: fillAttributes("schemeOutletDetails", schemeData),
            sectionEnabled: getSectionEnabled(schemeData),
            usabilityLimits: getUsabilityLimit(schemeData),
            inclusionData: {
                file: null,
                list: []
            },
            exclusionData: {
                file: null,
                list: []
            },
            banner: {
                uploadBanner: fillBannerDetails(schemeData)
            },
            recurrence: fillRecurrenceDetails(schemeData,editType),
            isPeriodWelcome:getIsPeriodUsability(schemeData),
            inclusionFileUrl: "",
            exclusionFileUrl: "",
        }
    };

    const batchCodeWithdes: { value: string, label: string }[] = createOptionsWithLabel("batchCode", store.getState().manageCoupons?.configData?.ALL_PRODUCTS);
    return enrichObject(finalObject, batchCodeWithdes, schemeData);
}
// {
//     "programLevel": "ILC",
//     "activeStatus": "active",
//     "endDate": "2024-02-09 18:29:59",
//     "criteria": "itemwise_group",
//     "schemeId": "04d881e8-6858-4079-b3b8-16b0bf1559f4",
//     "isMustBuy": false,
//     "startDate": "2024-02-01 18:30:00"
// isBundleTotalOrder:minimumAmount
// }
function getCouponTypeOption(data: Record<string, any>): string {
    const critera: string = data["criteria"];
    const programLevel: string = data["programLevel"];
    const minimumAmount: boolean = data["schemeCalculation"]["slabInfo"][0]["minimumAmount"];
    if (critera.toLowerCase() === "itemwise_group" && programLevel.toLowerCase() === "ilc" && minimumAmount) {
        return COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE;
    }
    else if (critera.toLowerCase() === "totalorder") {
        return COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE;
    }
    else if (critera.toLowerCase() === "totalorder_welcome") {
        return COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME
    }
    else if (critera.toLowerCase() === "itemwise_group" && programLevel.toLowerCase() === "ilc") {
        return COUPON_TYPE_OPTIONS_VALUE.BUNDLE
    }
    return COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON;
}
function getSchemeType(schemeData: Record<string, any>): string {
    return schemeData["schemeType"]
}

function getSkipMarketSelection(schemeData: Record<string, any>): boolean {
    if (schemeData["schemeOutletDetails"].size > 1) {
        return true
    }
    return false
}

function getIfMustBuy(schemeData: Record<string, any>): boolean {
    if (schemeData["schemeMustBuyAttributes"]) {
        return true;
    }
    return false;
}

function getQuantityUnit(schemeData: Record<string, any>): string {
    if (schemeData["schemeMustBuyAttributes"]) {
        if (schemeData["schemeMustBuyAttributes"][0]["unit"].toLowerCase() == "cs") {
            return "case";
        }
    }
    return "piece";
}

function fillMustBuyData(schemeData: Record<string, any>): any[] {
    if (schemeData["schemeMustBuyAttributes"]) {
        const transformedArray: { [key: string]: string[] }[] = schemeData["schemeMustBuyAttributes"].map((mustBuyObject: any) => {
            const newObj: { [key: string]: string[] } = {};
            for (const key in mustBuyObject) {
                if (key === "qty") {
                    newObj["min_qty"] = mustBuyObject[key];
                }
                else if (mustBuyObject[key] === "all" || key.toLowerCase() === "unit" || mustBuyObject[key] === null) {
                    continue;
                }
                else {
                    newObj[key] = [mustBuyObject[key]];
                }
            }
            const id: any = generateRandomId();
            newObj["id"] = id;
            return newObj;
        });


        return transformedArray;
    }
    return [];
}

function getSlabUnit(schemeData: Record<string, any>): string {
    return schemeData["schemeCalculation"]["rangeLevelUnit"].toLowerCase() === "amount" ? "Value" : "Qty";
}

function getSlabQuantityUnit(schemeData: Record<string, any>): string {
    const rangeLevelUnit = schemeData["schemeCalculation"]["rangeLevelUnit"].toLowerCase();
    return rangeLevelUnit === "cs" ? "case" : "piece";
}
function getSlab(schemeData: Record<string, any>): any[] {
    const transformedArray: { [key: string]: string[] }[] = schemeData["schemeCalculation"]["slabInfo"].map((slab: any) => {
        const newObj: { [key: string]: any } = {};
        newObj["start-range"] = slab["startRange"];
        newObj["end-range"] = slab["endRange"];
        newObj["discount-offered"] = slab["schemeBenefit"];
        newObj["coupon-description"] = slab["schemeDescription"];
        newObj["isEdit"] = false;
        newObj["final-order-value"] = slab["minimumAmount"]
        return newObj;
    }
    )
    return transformedArray;
}


function fillAttributes(attribute: string, data: Record<string, any>): any[] {
    const locationMissing: string[] = [];
    const outletMissing: string[] = [];
    if (attribute === "schemeLocationDetails" || attribute === "schemeOutletDetails") {
        const locationIds = new Set<string>();
        const outletIds = new Set<string>();
        const locationData = data["schemeLocationDetails"];
        const outletData = data["schemeOutletDetails"];
        if (locationData) {
            locationData.forEach((detail: { extendedAttributes: { id: string; }; }) => locationIds.add(detail?.extendedAttributes?.id));
        }
        if (outletData) {
            outletData.forEach((detail: { extendedAttributes: { id: string; }; }) => outletIds.add(detail?.extendedAttributes?.id));
        }
        let locationIdArr = Array.from(locationIds)
        let outletIdArr = Array.from(outletIds)
        if (locationData) {
            for (const id of locationIdArr) {
                if (!outletData?.find((detail: { extendedAttributes: { id: string; }; }) => detail?.extendedAttributes?.id === id)) {
                    outletMissing.push(id);
                }
            }
        }
        if (outletData) {
            for (const id of outletIdArr) {
                if (!locationData?.find((detail: { extendedAttributes: { id: string; }; }) => detail?.extendedAttributes?.id === id)) {
                    locationMissing.push(id);
                }
            }
        }
    }
    let combinedValues: any = [];

    if (attribute === "schemeLocationDetails" && data.schemeLocationDetails && data[attribute].length > 0) {
        let tabList = Object.keys(data[attribute][0]);
        combinedValues = [
            ...data[attribute],
            ...makeAllLocationEntry(locationMissing, tabList, data["schemeId"])
        ];
    } else if (attribute === "schemeOutletDetails" && data.schemeOutletDetails && data[attribute].length > 0) {
        let tabList = Object.keys(data[attribute][0]);
        combinedValues = [
            ...data[attribute],
            ...makeAllOutletEntry(outletMissing, tabList, data["schemeId"])
        ];
    } else {
        combinedValues = data[attribute];
    }

    return getObjectList(combinedValues, attribute);
}
function addExtraFields(values: Record<string, string>, mustHaveKeys: string[], valueToAdd: string) {
    const newObj = deepClone(values);
    return newObj;
}

function makeAllOutletEntry(outletMissing: string[], outletHeaderList: any[], schemeId: string): any {
    const ans: Record<string, string>[] = [];

    for (let id of outletMissing) {
        const res: Record<string, string> = {};
        outletHeaderList.forEach((header: string) => {
            if (header !== "extendedAttributes") {
                const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
                res[dbColName] = 'all'
            }
        })
        res["schemeId"] = schemeId;
        let newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["outlet"], 'all');
        newRes["extendedAttributes"] = { "id": id };
        ans.push(newRes);
    }
    return ans;
}

function makeAllLocationEntry(locationMissing: string[], locationHeaderList: any[], schemeId: string): any {
    const ans: Record<string, string>[] = [];
    for (let id of locationMissing) {
        const res: Record<string, string> = {};
        locationHeaderList.forEach((header: string) => {
            if (header !== "extendedAttributes") {
                const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
                res[dbColName] = 'all'
            }
        })
        res["schemeId"] = schemeId;
        let newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["location"], 'all');
        newRes["extendedAttributes"] = { "id": id };
        ans.push(newRes);
    }
    return ans;
}


function getObjectList(detailsList: any, attribute: string): any[] {
    const res: any[] = [];
    if (detailsList) {
        const transformedArray: { [key: string]: string[] | string }[] = detailsList.map((detail: any) => {
            const newObj: { [key: string]: string[] | string } = {};
            for (const key in detail) {
                let newKey: string = getNewKeyIfExist(key);
                if (key == "extendedAttributes") {
                    continue;
                }
                if (detail[key] === "all") {
                    newObj[newKey] = [];
                }
                else {
                    newObj[newKey] = [detail[key]];
                }
            }
            if (detail["extendedAttributes"] && detail["extendedAttributes"]?.["id"]) {
                newObj["id"] = detail["extendedAttributes"]["id"];
            }
            else if (detail["extendedAttributes"]?.["id"] === undefined && (attribute === "schemeLocationDetails" || attribute === "schemeOutletDetails")) {
                const id = "RecordWithoutId";
                newObj["id"] = id;
            }

            if (attribute === "schemeProductDetails") {
                const id: any = generateRandomId();
                newObj["id"] = id;
            }
            return newObj;
        });


        return transformedArray;
    }
    return [];
}

function getSectionEnabled(schemeData: Record<string, any>): sectionEnabledType {
    const sectionEnabled: sectionEnabledType = {
        "couponTypeOptions": true,
        "couponSchemeType": true,
        "schemeProductBifurcationsList": true,
        "mustBuy": true,
        "applicableSlab": true,
        "marketDetails": false,
        "inclusionList": false,
        "exclusionList": false,
        "banner": false
    }
    return sectionEnabled;
}

function getUsabilityLimit(schemeData: Record<string, any>): usabilityLimitsType {
    const usabilityLimits: usabilityLimitsType = {
        "startDate": dayjs(schemeData["startDate"]).format("YYYY-MM-DDTHH:mm:ss"),
        "endDate": dayjs(schemeData["endDate"]).format("YYYY-MM-DDTHH:mm:ss"),
        "useOnce":schemeData["schemeCalculation"]["usageLimit"]===1,
        "percentageMaxAmount":schemeData?.schemeCalculation?.maxDiscount ?? ""
    }
    return usabilityLimits;
}

function enrichObject(finalObject: manageCouponInitialStateType, batchCodeWithdes: { value: string, label: string }[], schemeData: Record<string, any>): manageCouponInitialStateType {
    finalObject = enrichBatchCode(finalObject, batchCodeWithdes);
    finalObject = enrichLocationAndOutlet(finalObject);
    finalObject = enrichSlabs(finalObject);
    if (finalObject.data.schemeOutletBifurcationsList.length === 0 && finalObject.data.schemeLocationBifurcationsList.length === 0) {
        finalObject.data.skipMarketSelection = true;
    }
    finalObject = updateMarketDetails(finalObject, schemeData);
    return finalObject;
}



function getNewKeyIfExist(key: string): string {
    let newKey = DB_COLUMN_NAME_MAP_COLUMN_NAME[key]
    if (newKey) {
        return newKey
    }
    return key;
}
async function getProductEntities(schemeData: Record<string, any>): Promise<string[] | undefined> {
    const headersList = await getHeadersList();


    return headersList;
}


function enrichBatchCode(finalObject: manageCouponInitialStateType, batchCodeWithdes: { value: string; label: string; }[]): manageCouponInitialStateType {
    finalObject.data.schemeProductBifurcationsList.forEach((product) => {
        const batchCodeArr: string[] = product["batchCode"];
        if (batchCodeArr && batchCodeArr.length > 0) {
            product["batchCode"] = batchCodeArr.map(batchCode => {
                const value: string | undefined = batchCodeWithdes.find(item => item.value.includes(batchCode))?.value;
                return value ?? batchCode;
            })
        }
    })
    return finalObject;
}

function enrichLocationAndOutlet(finalObject: manageCouponInitialStateType): manageCouponInitialStateType {
    finalObject.data.schemeOutletBifurcationsList = getNewList(finalObject.data.schemeOutletBifurcationsList);
    finalObject.data.schemeLocationBifurcationsList = getNewList(finalObject.data.schemeLocationBifurcationsList);
    return finalObject;
}
function getNewList(list: any[]): any[] {
    let newList: any[] = [];
    list.map((current: Record<string, any>) => {
        const existing = newList.find(item => item["id"] === current["id"]);
        if (existing) {
            for (const key in current) {
                if (key === "id") {
                    continue;
                }
                const valueToAdd = current[key]?.[0];
                if (valueToAdd !== undefined) {
                    existing[key] = [...existing[key], valueToAdd];
                }
            }
        }
        else {
            newList.push(current);
        }
    })
    return newList;
}

function enrichSlabs(finalObject: manageCouponInitialStateType): manageCouponInitialStateType {
    finalObject.data.slabInfo.data.forEach(slab => {
        slab["id"] = generateRandomId();
    });
    return finalObject;
}

function checkIfOverAndAbove(schemeData: Record<string, any>): boolean | undefined {
    if (schemeData["extendedAttributes"]?.["OAAC"]) {
        return true;
    }
    return false;
}

function fillBannerDetails(schemeData: Record<string, any>): { active: boolean; imageUrl?: string | null | undefined; bannerPriority?: string | null | undefined; } {
    return {
        imageUrl: schemeData?.["bannerUrl"] || null,
        bannerPriority: schemeData?.["bannerPriority"] || null,
        active: schemeData?.["bannerUrl"] !== "" && schemeData?.["bannerUrl"] !== null && schemeData?.["bannerUrl"] !== undefined
    }

}

function fillRecurrenceDetails(schemeData: Record<string, any>,editType:string):Recurrence {
    const recurrence:Recurrence= {
        dateStartEnd: { startDate: schemeData?.["startDate"], endDate: schemeData?.["endDate"] },// start and end date for the coupon
        activePeriodCustomDates: schemeData?.activeDates || [],// selected active dates
        activePeriodDays: schemeData?.activeDays || [],// select ed active days
        activePeriodWeeks: schemeData?.activeWeeks || [],// selected active weeks
        activePeriodMonths: schemeData?.activeMonths || [],// selected active months
        isActivePeriodSaved: editType==="edit"?true:false,// is the activeperiod saved
        savedCalendar: "",
        usabilityLimit: schemeData?.schemeCalculation?.["usabilityPeriodLimit"] || "",// is the limit for that usability period
        usability: schemeData?.schemeCalculation?.["usabilityPeriod"] || "",//is the usability period
        orderResetFrequency: schemeData?.schemeCalculation?.["nthOrderPeriod"],// period for with the orders can be placed
        nDaysFromActivation: "",// number of days from start till when the coupn will be active
        numberOfPurchases: schemeData?.schemeCalculation?.["nthOrderNumber"] || "",// number of orders that need be placed for re activation
        couponLife: schemeData?.schemeCalculation?.["outletLimitOnOrder"] || "",// total times the coupon can be used
        skipUsability: false,
        skipNthOrder: true,
        skipActivePeriod: false,
        skipCouponLife: false,
        initialUsabilityFilled: ((schemeData?.schemeCalculation?.["usabilityPeriodLimit"] !== null && schemeData?.schemeCalculation?.["usabilityPeriod"] !== null) && schemeData?.schemeCalculation?.["usabilityPeriodLimit"] !== "" && schemeData?.schemeCalculation?.["usabilityPeriod"] !== ""),
        iniUsabilityLimit: schemeData?.schemeCalculation?.["usabilityPeriodLimit"],
        iniUsability: schemeData?.schemeCalculation?.["usabilityPeriod"],
        iniCouponLife: schemeData?.schemeCalculation?.["outletLimitOnOrder"],
        couponTimings: createCouponTiming(schemeData?.activeTime || [])
    }
    recurrence.nDaysFromActivation = getnDays(schemeData);
    const finalRecurrence = updateIndicators(recurrence);
    return finalRecurrence;
}

function createCouponTiming(timingsData: Array<string>): CouponTimingSlab[] {
    if (!timingsData) return [];

    let ans: CouponTimingSlab[] = [];
    for (let combinedTime of timingsData) {
        const [startTime, endTime] = combinedTime.split('&');
        ans.push({
            id: generateRandomId(),
            isSaved: true,
            st: convertTimeStringToCouponTiming(startTime),
            et: convertTimeStringToCouponTiming(endTime)
        })
        // const st = convertTimeStringToCouponTiming(startTime);
        // console.log("is start date valid: ",st.isValid());
    }
    return ans;
}

function updateMarketDetails(finalObject: manageCouponInitialStateType, schemeData: Record<string, any>): manageCouponInitialStateType {
    if (finalObject.data.schemeOutletBifurcationsList.length != finalObject.data.schemeLocationBifurcationsList.length) {
        finalObject.data.schemeOutletBifurcationsList.map(item => {
            if (item["id"] === "RecordWithoutId") {
                finalObject.data.schemeLocationBifurcationsList.push(getAllValue(schemeData))
                return
            }

        })
    }
    return finalObject;
}

function getAllValue(schemeData: Record<string, any>): any {
    {
        const newObj: { [key: string]: string[] | string } = {};
        const detail = schemeData["schemeLocationDetails"]?.[0];
        for (const key in detail) {
            let newKey: string = getNewKeyIfExist(key);
            if (key == "extendedAttributes") {
                continue;
            }
            newObj[newKey] = [];
        }
        newObj["id"] = "RecordWithoutId";
        return newObj;
    }
}
// function getMarketTabsList(schemeData: Record<string, any>, attribute: string): any[] | undefined {
//     if(schemeData[attribute]){
//         const data: Record<string, string> = schemeData[attribute][0];
//         var res: string[] = [];
//         for (var key in data) {
//             key=getNewKeyIfExist(key);
//             res.push(key);
//         }
//         return res;
//     }
//     return ;
// }


function getIsPeriodUsability(schemeData: Record<string, any>): boolean {
    if (schemeData["extendedAttributes"]?.["isWTOCL"] !== null && schemeData["extendedAttributes"]?.["isWTOCL"] !== undefined && schemeData["extendedAttributes"]?.["isWTOCL"] == true) {
        return true;
    }
    return false;
}

function getnDays(schemeData: Record<string, any>): string {
    if (schemeData["extendedAttributes"]?.["nd"]) {
        return schemeData["extendedAttributes"]["nd"]
    }
    return "";
}
function updateIndicators(recurrence: Recurrence): Recurrence {
    const rec: Recurrence = deepClone(recurrence);
    if (rec.activePeriodDays.length > 0 || rec.activePeriodWeeks.length > 0 || rec.activePeriodMonths.length > 0 || rec.nDaysFromActivation != "") {
        rec.isActivePeriodSaved = true;
        rec.skipActivePeriod = false;
    }
    rec.numberOfPurchases != "" ? rec.skipNthOrder = false : rec.skipNthOrder = true;
    rec.nDaysFromActivation != "" ? rec.savedCalendar = "1" : rec.savedCalendar = "0";
    return rec;
}

